export default "__VITE_ASSET__f2ntnBK4__"